"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.readOrCadDsnCfbEntries = readOrCadDsnCfbEntries;
const cfb_interop_1 = require("../../../cfb-interop");
function toUint8Array(content) {
    if (!content) {
        return undefined;
    }
    if (content instanceof Uint8Array) {
        return content;
    }
    if (content instanceof ArrayBuffer) {
        return new Uint8Array(content);
    }
    if (Array.isArray(content)) {
        return Uint8Array.from(content);
    }
    return undefined;
}
function baseName(path) {
    const withoutTrailing = path.endsWith('/') ? path.slice(0, -1) : path;
    const slash = withoutTrailing.lastIndexOf('/');
    return slash === -1 ? withoutTrailing : withoutTrailing.slice(slash + 1);
}
function storagePath(path) {
    const withoutTrailing = path.endsWith('/') ? path.slice(0, -1) : path;
    const slash = withoutTrailing.lastIndexOf('/');
    return slash === -1 ? '' : withoutTrailing.slice(0, slash);
}
function readOrCadDsnCfbEntries(fileContents) {
    const container = cfb_interop_1.CFB.read(fileContents, { type: 'array' });
    const fileIndex = container.FileIndex;
    return fileIndex.map((entry, index) => {
        const path = container.FullPaths[index] ?? '';
        const content = toUint8Array(entry.content);
        return {
            path,
            name: baseName(path),
            type: entry.type ?? 0,
            size: entry.size ?? content?.byteLength ?? 0,
            storagePath: storagePath(path),
            ...(content ? { content } : {}),
        };
    });
}
//# sourceMappingURL=OrcadDsnCfbCfb.js.map